import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableBilling = Loadable({
  loader: function loader() {
    return import('../Billing.jsx');
  },
  loading: ComponentLoading
});
export default LoadableBilling;